<template>
  <UserList search-type="5" />
</template>

<script>
import UserList from '@/components/UserList'

export default {
  name: 'SearchUsers',
  components: {
    UserList,
  }
}
</script>
